import { render } from "./tagBubbles.vue?vue&type=template&id=7e59be0e"
import script from "./tagBubbles.vue?vue&type=script&lang=js"
export * from "./tagBubbles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__